import React from 'react';
import styles from '../HomeV3.module.css';

interface Props { onRetry: () => void; }

export function DashboardError({ onRetry }: Props) {
    return (
        <main className={styles.dashboard}>
            <section className={styles.panel} role="alert">
                <p className={styles.eyebrow}>Home dashboard</p>
                <h1>We couldn't load your dashboard</h1>
                <p className={styles.muted}>Try again. If the issue continues, contact support.</p>
                <button className={styles.primaryButton} type="button" onClick={onRetry}>Retry</button>
            </section>
        </main>
    );
}
